/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import "./index.css";

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App path={window.location.pathname} />
  </StrictMode>
);

if (import.meta.hot) {
  // Dev: root is hollow (no pre-render) and HMR re-runs this module — reuse one
  // root across reloads. https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
  (import.meta.hot.data.root ??= createRoot(elem)).render(app);
} else if (elem.firstChild) {
  // Prod: server pre-rendered the markup — hydrate it in place.
  hydrateRoot(elem, app);
} else {
  // Fallback (e.g. an unmatched route served the hollow shell).
  createRoot(elem).render(app);
}
